import(/* webpackMode: "eager" */ "/codebuild/output/src1411907473/src/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorTracker"] */ "/codebuild/output/src1411907473/src/app/src/components/ErrorTracker/ErrorTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebVitalsReporter"] */ "/codebuild/output/src1411907473/src/app/src/components/WebVitalsReporter/WebVitalsReporter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AwsRumProvider"] */ "/codebuild/output/src1411907473/src/app/src/providers/AwsRumProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/codebuild/output/src1411907473/src/app/src/providers/QueryProvider.tsx");
